import { Component, ViewEncapsulation, ViewChild, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from '../../../shared/services/user.service';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../shared/services/loading.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { EquipmentDetails } from '../../manage-equipment/models/manage-equipment.model';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '../../../../app/translate';
import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AppService } from '../../../../app/app.service';
import { Condition } from '../../interpretation/models/interpretation.model';
import { CreateNewInspectionViewModel, InspectionAdditionalObservationListsViewModel, PopupEndPoint, InspectionAdditionalObservationImagesVM, SystemInspectionDetailView, InspectionValidationViewVM, InspectionValidatorRequest } from '../models/create-inspection.model';
import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { NewInspectionService } from '../services/new-inspection.service';
import { InspectionSystemsComponent } from './inspection-systems/inspection-systems.component';
import { ConditionCommentModalComponent, CommentPopupRequestPageAndFunc } from '../../interpretation/components/condition-comment-modal/condition-comment-modal.component';
import { FindInspectedEquipmentPopupComponent } from './find-inspected-equipment-popup/find-inspected-equipment-popup.component';
import { InspectionReviewComponent } from './inspection-review/inspection-review.component';
import { ViewPhotoComponent } from '../../interpretation/components/view-photo/view-photo.component';
import { NewObservationListPropertyComponent } from '../add-inspection-observation-lists/new-observation-list-property/new-observation-list-property.component';
import { SetupUndercarriageService } from '../../setup-undercarriage';
import { CustomeEvaluationRangeVM } from '../../CustomEval/custom-eval.model';
import { CustomEvalService } from '../../CustomEval/custom-eval.service';
import { ConfirmDialogComponent } from '../../interpretation/components/confirm-dialog/confirm-dialog.component';
import { CustomerServiceIdentity } from '../../IDENTITY_WEB/services/customer.service';
import { SendReportModalComponent } from '../../interpretation/components/send-report-modal/send-report-modal.component';
import { InterpretationService } from '../../interpretation/interpretation.service';
import { AdditionalComponentAnswerComponent } from '../../interpretation/components/additional-component-answer/additional-component-answer.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ModelBaseObservations } from '../../setup-models/setup-models.model';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PreferencesService } from '../../../modules/preferences/preferences.service';
@Component({

  selector: 'app-create-new-inspection',
  templateUrl: './create-new-inspection.component.html',
  styleUrls: ['./create-new-inspection.component.scss'],
  animations: [

    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger('fadeInList', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger(
      'fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )
  ],

  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    //{ provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
  encapsulation: ViewEncapsulation.None
})



export class CreateNewInspectionComponent implements OnDestroy {

  totalInspDistance: number = 0;
  overviewIsLoading = true;
  loadingEquipment = true;
  private _subscriptions: Subscription[] = [];
  equipmentId: number;
  equipmentDetails: EquipmentDetails = new EquipmentDetails();

  currentStep = 0;
  underfootConditions = [
    { value: 0, Title: this.translate('Low') },
    { value: 1, Title: 'Medium' },
    { value: 2, Title: 'High' },
  ];

  Condition = Condition;
  userLanguage = 'english';

  GeneralInfoGroup: FormGroup;
  // LeftSideComponentGroup: FormGroup;
  // RightSideComponentGroup: FormGroup;

  saving = false;
  inspection: CreateNewInspectionViewModel;

  impact: FormControl;
  abrasive: FormControl;
  moisture: FormControl;
  packing: FormControl;
  inspectionDate: FormControl;
  smuReading: FormControl;
  forwardHr: FormControl;
  forwardKm: FormControl;
  reverseHr: FormControl;
  reverseKm: FormControl;

  pmuReading: FormControl;

  trackSagL: FormControl;
  trackSagR: FormControl;

  dryJointL: FormControl;
  dryJointR: FormControl;

  scallopL: FormControl;
  scallopR: FormControl;
  cannonExtL: FormControl;
  cannonExtR: FormControl;

  linkNoL: FormControl;
  linkNoR: FormControl;

  inspectionNotes: FormControl;
  jobsiteNotes: FormControl;

  warningMessage = '';

  spaceComment = ' ';
  stepOneSubmitted = false;
  inspectionId: number;
  showWaring: boolean;
  _subscription: Subscription;
  inited: boolean;
  showUCCondition: boolean = false;
  workOrder: FormControl;
  @ViewChild('LeftChain')
  leftChainSystem: InspectionSystemsComponent;

  @ViewChild('RightChain')
  rightChainSystem: InspectionSystemsComponent;

  @ViewChild('LeftFrame')
  leftFrameSystem: InspectionSystemsComponent;

  @ViewChild('RightFrame')
  rightFrameSystem: InspectionSystemsComponent;


  @ViewChild('LeftChainReview')
  leftChainSystemReview: InspectionReviewComponent;

  @ViewChild('RightChainReview')
  rightChainSystemReview: InspectionReviewComponent;

  @ViewChild('LeftFrameReview')
  leftFrameSystemReview: InspectionReviewComponent;

  @ViewChild('RightFrameReview')
  rightFrameSystemReview: InspectionReviewComponent;

  creatingNewInspection = false;

  submitted = false;
  navigationSubscription;
  inpsectionDraftId: number;
  public todate = new Date();


  measurementUnit = 'mm';
  measurementDistance = 'km';


  FamilyImage_Chain: string
  FamilyImage_Frame: string
  popupEndPoint = PopupEndPoint.ObservationListCreateInspection;

  EvalautionRange: CustomeEvaluationRangeVM;
  isBogieDataLoaded: boolean = false;
  observationInfo: ModelBaseObservations[] = [];
  hasCRoller: boolean = false;
  showCRoller: boolean = false;
  showFrameConfigurtaion: boolean = false;
  showCannonType: boolean = false;
  showTrackSag: boolean = true;
  showCannonExt: boolean = true;
  showScallop: boolean = true;
  showDryJoints: boolean = true;
  showNumberOfLinks: boolean = true;
  showUnderFootConditions: boolean = true;
  showWorkOrder: boolean = true;
  // --AllOptionsEnable: boolean ;
  @Output() measurementPointUpdated = new EventEmitter();
  systemData: SystemInspectionDetailView;
  userUOM: string;
  pageTitle: string = "New Inspection";
  othersTabDataLoaded: boolean = false;

  constructor(private _user: UserService,
    private cdr: ChangeDetectorRef,
    private _router: Router,
    private route: ActivatedRoute,
    private _notification: NotificationsService,
    private _loading: LoadingService,
    private _equipmentService: ManageEquipmentService,
    private _sanitizer: DomSanitizer,
    private _translate: TranslateService,
    private _formBuilder: FormBuilder,
    private _appService: AppService,
    private _inspectionService: NewInspectionService,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialog: MatDialog,
    private _setupService: SetupUndercarriageService,
    private _ref: ChangeDetectorRef,
    private _evalService: CustomEvalService,
    private _customerService: CustomerServiceIdentity,
    private _interp: InterpretationService,
    private datePipe: DatePipe,
    private _pref: PreferencesService
  ) {
    this.navigationSubscription = this._router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.setup();
      }
    });
  }
  uploadedObservationListImage() {
    this.reloadAdditionalObservationList();
  }



  setup() {
    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.inspectionId = +this.route.snapshot.paramMap.get('id2');
    if (this.inspectionId === undefined || this.inspectionId === 0) {
      this._appService.setPageTitle('New Inspection');
    }
    else {
      this.pageTitle = "Edit Inspection";
      this._appService.setPageTitle('Edit Inspection');
    }
    console.log("inspectionId:", this.inspectionId);
    this.initPage();
  }
  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  isBasicUser: number;
  initPage() {
    //console.log("initPage(1)", "");
    this.overviewIsLoading = true;
    this.loadPreferences();
    this.getUserUOM();
    this._customerService.CheckUCUserType().subscribe(result => {
      this.isBasicUser = result;
    });
    this.inspection = new CreateNewInspectionViewModel(this.equipmentId);
    this.loadEquipment(this.equipmentId);
    this.initStepOneFormControls();
    if (this.inspectionId === 0) {
      this.creatingNewInspection = true;
      this.getInspectionDraft();
    }
    console.log("inspection:", this.inspection, this.creatingNewInspection);
    //else {
    //  this.creatingNewInspection = false;
    //  this.populateInspectionView();
    //}
    this._subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2)));
  }

  getUserUOM() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOM = res.UnitOfMeasurementName;
    })
  }
  LoadEvalautionForEquipment() {
    this._evalService.GetSelectedLevelRangesForSelectedEquipment(this.equipmentId).subscribe(res => {
      //console.log("res", res);
      this.EvalautionRange = res;
    })
  }

  populateInspectionView() {
    //console.log("populateInspectionView(4)", "");
    //this._loading.startLoading();
    //this._inspectionService.getInspection(this.equipmentId, this.inspectionId).subscribe(r => {
    //  this.inspection = r;
    //  if (this.inspection.Jobsite != "") {
    //    //console.log("Inspection: ", r);
    //    this.JobsiteName = this.inspection.Jobsite;
    //    this.JobsiteId = this.inspection.JobsiteId;
    //    this.Smu = this.inspection.SMUReading;
    //    this.Ltd = this.inspection.LTD;
    //  }
    //  this.observationInfo=this.inspection.observationInfo;
    //  this.hasCRoller=this.inspection.hasCRoller;
    //  this.showCRoller = this.inspection.showCRoller;
    //  this.totalDistance =( this.inspection.TravelProperties.ForwardTravelKm==null?0: this.inspection.TravelProperties.ForwardTravelKm) +  (this.inspection.TravelProperties.ReverseTravelKm==null?0:this.inspection.TravelProperties.ReverseTravelKm); 
    //  this.inpsectionDraftId = r.InspectionId;
    //  this._loading.finishedLoading();
    //  setTimeout(() => {
    //    this.overviewIsLoading = false;
    //    this.inited = true;
    //  }, 3000);
    //});
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this._ref.detectChanges();
  }

  getInspectionDraft() {
    this._loading.startLoading();
    this._inspectionService.getInspectionDraft(this.equipmentId).subscribe(r => {
      this.inspection = r;
      this.observationInfo = this.inspection.observationInfo;
      this.hasCRoller = this.inspection.hasCRoller;
      this.showCRoller = this.inspection.showCRoller;
      this.inpsectionDraftId = r.InspectionId;
      this.inspection.InspectionId = 0;
      this._loading.finishedLoading();
      this.overviewIsLoading = false;
    });
    console.log("this.inpsectionDraftId:", this.inpsectionDraftId);
  }

  calculateTotalDistance() {
    //console.log("this.totalInspDistance:", this.totalInspDistance);
    this.totalInspDistance = 0;
    if (this.inspection != null)
      if (this.inspection.TravelProperties != null)
        this.totalInspDistance = (this.inspection.TravelProperties.ForwardTravelKm != null ? this.inspection.TravelProperties.ForwardTravelKm : 0) + (this.inspection.TravelProperties.ReverseTravelKm != null ? this.inspection.TravelProperties.ReverseTravelKm : 0);
    //console.log("this.totalInspDistance:", this.totalInspDistance);
  }
  isRSH: boolean = false;
  loadEquipment(equipmentId) {
    //console.log("loadEquipment(3)", this.JobsiteName);
    this.loadingEquipment = true;
    this._loading.startLoading();
    this._equipmentService.getEquipmentDetails(this.equipmentId).subscribe(async equipment => {
      //this.equipmentDetails = equipment;
      if (this.inspectionId > 0) {

        this.creatingNewInspection = false;
        //console.log("populateInspectionView(4)", "");
        this._loading.startLoading();
        await this._inspectionService.getInspection(this.equipmentId, this.inspectionId).subscribe((r: any) => {
          this.equipmentDetails = equipment;
          console.log("tthis.FamilyName:", this.equipmentDetails.Family);
          this.getFamilyDetails(this.equipmentDetails.Family);
          this.inspection = r;
          console.log("Inspection: ", r);
          console.log("InspectionObject: ", this.inspection);
          if (r.InspectionEqImagePath != null && r.InspectionEqImagePath != "")
            this.equipmentDetails.EquipmentPhoto = r.InspectionEqImagePath;
          if (this.inspection.Jobsite != "")
            this.equipmentDetails.JobsiteName = this.inspection.Jobsite;
          if (this.inspection.JobsiteId > 0)
            this.equipmentDetails.JobsiteId = this.inspection.JobsiteId;
          if (this.inspection.SMUReading > 0)
            this.equipmentDetails.Smu = this.inspection.SMUReading;


          if (this.inspection.LTD > 0)
            this.equipmentDetails.Ltd = this.inspection.LTD;

          this.observationInfo = this.inspection.observationInfo;
          this.hasCRoller = this.inspection.hasCRoller;
          this.showCRoller = this.inspection.showCRoller;
          this.totalInspDistance = (this.inspection.TravelProperties.ForwardTravelKm == null ? 0 : this.inspection.TravelProperties.ForwardTravelKm) + (this.inspection.TravelProperties.ReverseTravelKm == null ? 0 : this.inspection.TravelProperties.ReverseTravelKm);
          this.inpsectionDraftId = r.InspectionId;
          this.inspection.BogieShimLeft = r.BogieShimLeft;
          this.inspection.BogieShimRight = r.BogieShimRight;
          console.log('At Parent Component - BogieShimLeft', this.inspection.BogieShimLeft);
          console.log('At Parent Component - BogieShimRight', this.inspection.BogieShimRight);
          this.isBogieDataLoaded = true;
          this._loading.finishedLoading();
          setTimeout(() => {
            this.overviewIsLoading = false;
            this.inited = true;
          }, 3000);
        });
      }
      else {
        this.equipmentDetails = equipment;

        console.log("tthis.FamilyName:", this.equipmentDetails.Family);
        this.getFamilyDetails(this.equipmentDetails.Family);
        this.isBogieDataLoaded = true;
      }

      console.log("this.equipmentDetails:", this.equipmentDetails);
      this.loadingEquipment = false;
      //if(this.equipmentDetails.FamilyId==177 || this.equipmentDetails.FamilyId==203){
      if (this.equipmentDetails.ShowPropelHrsPerc) {
        this.isRSH = true;
      } else {
        this.isRSH = false;
      }
      console.log("this.equipmentDetails.ShowPropelHrsPerc:", this.equipmentDetails.ShowPropelHrsPerc);

      this.LoadEvalautionForEquipment();
      this._loading.finishedLoading();
      this.cdr.detectChanges();
    });


  }


  AddNewObservationList() {
    const dialogRef = this._dialog.open(NewObservationListPropertyComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        inspectionDraftId: this.inpsectionDraftId,
        createfromObsList: false,
        inspectionId: this.inspectionId,
        additionalObservationListCheck: this.inspection?.AdditionalObservationDrafts
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.close) {
        if (this.inspectionId == undefined) {
          this.reloadAdditionalObservationList();
        }
        else {
          const newObservation: InspectionAdditionalObservationListsViewModel = {
            Id: 0,
            InspectionDraftId: this.inpsectionDraftId,
            Title: result.title,
            Comment: null,
            Image: null,
            ReferenceId: null,
            InspectionAdditionalObId: null,
            ObsImages: [],
            AnswerList: [],
            QuestionTypeId: 0,
            HasAnswerd: false,
            wornPercent: null
          };
          if (!this.inspection.AdditionalObservationDrafts) {
            this.inspection.AdditionalObservationDrafts = [];
          }
          this.inspection.AdditionalObservationDrafts.push(newObservation);
        }
      }
    });
  }
  getFormatedDate = (currentDate) => {

    //console.log("curernt ", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };

  private initStepOneFormControls() {
    this.stepOneSubmitted = false;
    this.inited = false;
    this.impact = new FormControl(this.inspection.UnderfootConditions.Impact, [Validators.required]);
    this.abrasive = new FormControl(this.inspection.UnderfootConditions.Abrasive, [Validators.required]);
    this.moisture = new FormControl(this.inspection.UnderfootConditions.Moisture, [Validators.required]);
    this.packing = new FormControl(this.inspection.UnderfootConditions.Packing, [Validators.required]);
    this.inspectionDate = new FormControl(moment(new Date(this.inspection.InspectionDate)), [Validators.required]);
    this.smuReading = new FormControl(this.inspection.SMUReading, [Validators.required]);
    this.workOrder = new FormControl(this.inspection.WorkOrder, []);

    this.pmuReading = new FormControl(this.inspection.PMUReading, []);

    this.forwardHr = new FormControl(this.inspection.TravelProperties.ForwardTravelHr, [Validators.min(0)]);
    this.forwardKm = new FormControl(this.inspection.TravelProperties.ForwardTravelKm, [Validators.min(0)]);
    this.reverseHr = new FormControl(this.inspection.TravelProperties.ReverseTravelHr, [Validators.min(0)]);
    this.reverseKm = new FormControl(this.inspection.TravelProperties.ReverseTravelKm, [Validators.min(0)]);


    this.trackSagL = new FormControl(this.inspection.ObservationReadings.TrackSagL, [Validators.min(0)]);
    this.trackSagR = new FormControl(this.inspection.ObservationReadings.TrackSagR, [Validators.min(0)]);

    this.dryJointL = new FormControl(this.inspection.ObservationReadings.NoDryJointsL, [Validators.min(0)]);
    this.dryJointR = new FormControl(this.inspection.ObservationReadings.NoDryJointsR, [Validators.min(0)]);

    this.scallopL = new FormControl(this.inspection.ObservationReadings.ScallopL, [Validators.min(0)]);
    this.scallopR = new FormControl(this.inspection.ObservationReadings.ScallopR, [Validators.min(0)]);

    this.cannonExtL = new FormControl(this.inspection.ObservationReadings.CannonExtL, [Validators.min(0)]);
    this.cannonExtR = new FormControl(this.inspection.ObservationReadings.CannonExtR, [Validators.min(0)]);

    this.linkNoL = new FormControl(this.inspection.ObservationReadings.LinkNoL, [Validators.min(0)]);
    this.linkNoR = new FormControl(this.inspection.ObservationReadings.LinkNoR, [Validators.min(0)]);

    this.inspectionNotes = new FormControl(this.inspection.InspectionNotes, []);
    this.jobsiteNotes = new FormControl(this.inspection.JobsiteNotes, []);

    this.GeneralInfoGroup = new FormGroup({
      impact: this.impact,
      abrasive: this.abrasive,
      packing: this.packing,
      moisture: this.moisture,

      inspectionDate: this.inspectionDate,
      smuReading: this.smuReading,
      pmuReading: this.pmuReading,
      workOrder: this.workOrder,
      ForwardTravelHours: this.forwardHr,
      ReverseTravelHours: this.reverseHr,
      ForwardTravelKms: this.forwardKm,
      ReverseTravelKms: this.reverseKm,
      WorkOrder: this.workOrder,

      TrackSagLeft: this.trackSagL,
      TrackSagRight: this.trackSagR,
      DryJointLeft: this.dryJointL,
      DryJointRight: this.dryJointR,
      CannonExtLeft: this.cannonExtL,
      CannonExtRight: this.cannonExtR,
      ScallopLeft: this.scallopL,
      ScallopRight: this.scallopR,

      LinkNoLeft: this.linkNoL,
      LinkNoRight: this.linkNoR,
      JobsiteNotes: this.jobsiteNotes,
      InspectionNotes: this.inspectionNotes,
    });
    setTimeout(() => {
      this.inited = true;
    }, 3000);
  }
  reloadObservations(condition: Condition, event: any) {
    console.log("reloadObservations event:", event);
    this._loading.startLoading();
    switch (condition) {
      case Condition.TrackSagL:
        this.inspection.ObservationImages.TrackSagLImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.TrackSagR:
        this.inspection.ObservationImages.TrackSagRImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.CannonExtL:
        this.inspection.ObservationImages.CannonExtLImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.CannonExtR:
        this.inspection.ObservationImages.CannonExtRImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.DryJointsL:
        this.inspection.ObservationImages.NoDryJointsLImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.DryJointsR:
        this.inspection.ObservationImages.NoDryJointsRImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.ScallopL:
        this.inspection.ObservationImages.ScallopLImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.ScallopR:
        this.inspection.ObservationImages.ScallopRImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.LinkNoL:
        this.inspection.ObservationImages.LinkNoLImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.LinkNoR:
        this.inspection.ObservationImages.LinkNoRImage = event.removed ? '' : event.imageUrl;
        break;
      case Condition.SMUImageHour:
        this.inspection.SMUImages = event.removed ? '' : event.imageUrl;
        break;
    }
    this._loading.finishedLoading();
    this.overviewIsLoading = false;
    //if (this.creatingNewInspection) {

    //  switch (condition) {
    //    case Condition.TrackSagL:
    //      this.inspection.ObservationImages.TrackSagLImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.TrackSagR:
    //      this.inspection.ObservationImages.TrackSagRImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.CannonExtL:
    //      this.inspection.ObservationImages.CannonExtLImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.CannonExtR:
    //      this.inspection.ObservationImages.CannonExtRImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.DryJointsL:
    //      this.inspection.ObservationImages.NoDryJointsLImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.DryJointsR:
    //      this.inspection.ObservationImages.NoDryJointsRImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.ScallopL:
    //      this.inspection.ObservationImages.ScallopLImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.ScallopR:
    //      this.inspection.ObservationImages.ScallopRImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.LinkNoL:
    //      this.inspection.ObservationImages.LinkNoLImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.LinkNoR:
    //      this.inspection.ObservationImages.LinkNoRImage = event.removed ? '' : event.imageUrl;
    //      break;
    //    case Condition.SMUImageHour:
    //      this.inspection.SMUImages = event.removed ? '' : event.imageUrl;
    //      break;
    //  }
    //  this._loading.finishedLoading();
    //  this.overviewIsLoading = false;

    //}
    //else {
    //  this._inspectionService.refreshInspection(this.equipmentId, this.inspectionId).subscribe(r => {
    //    //console.log("refreshInspection__", r)
    //    switch (condition) {
    //      case Condition.TrackSagL:
    //        this.inspection.ObservationImages.TrackSagLImage = r.ObservationImages.TrackSagLImage;
    //        break;
    //      case Condition.TrackSagR:
    //        this.inspection.ObservationImages.TrackSagRImage = r.ObservationImages.TrackSagRImage;;
    //        break;
    //      case Condition.CannonExtL:
    //        this.inspection.ObservationImages.CannonExtLImage = r.ObservationImages.CannonExtLImage;;
    //        break;
    //      case Condition.CannonExtR:
    //        this.inspection.ObservationImages.CannonExtRImage = r.ObservationImages.CannonExtRImage;;
    //        break;
    //      case Condition.DryJointsL:
    //        this.inspection.ObservationImages.NoDryJointsLImage = r.ObservationImages.NoDryJointsLImage;;
    //        break;
    //      case Condition.DryJointsR:
    //        this.inspection.ObservationImages.NoDryJointsRImage = r.ObservationImages.NoDryJointsRImage;;
    //        break;
    //      case Condition.ScallopL:
    //        this.inspection.ObservationImages.ScallopLImage = r.ObservationImages.ScallopLImage;;
    //        break;
    //      case Condition.ScallopR:
    //        this.inspection.ObservationImages.ScallopRImage = r.ObservationImages.ScallopRImage;;
    //        break;
    //      case Condition.LinkNoL:
    //        this.inspection.ObservationImages.LinkNoLImage = r.ObservationImages.LinkNoLImage;;
    //        break;
    //      case Condition.LinkNoR:
    //        this.inspection.ObservationImages.LinkNoRImage = r.ObservationImages.LinkNoRImage;;
    //        break;
    //      case Condition.SMUImageHour:
    //        this.inspection.SMUImages = r.SMUImages;;
    //        break;

    //    }
    //    //this.inspection.ObservationImages = r.ObservationImages;
    //    this._loading.finishedLoading();
    //  });
    //}

  }

  changeEquipment() {
    this._dialog.open(FindInspectedEquipmentPopupComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  updateInspectionDraft(step: number) {
    if (!this.inited || this.overviewIsLoading || this.loadingEquipment) return;

    //const rightDate = new Date(model.InspectionDate);
    //model.InspectionDate = rightDate;
    this.inspection.UOD = this.measurementDistance;
    //this.inspection.StringDate = this.getFormatedDate(new Date(this.inspection.InspectionDate));
    console.log('this.inspection.InspectionDate', this.inspection.InspectionDate);
    this.inspection.StringDate = this.datePipe.transform(this.inspection.InspectionDate, 'MM/dd/yyyy');
    this.inspection.InspectionId = this.inspectionId;
    console.log("UpdateData", this.inspection.StringDate)
    console.log("inspectionshim", this.inspection);
    if (step == 3) {
      const leftData = localStorage.getItem("bogieShimLeft");
      this.inspection.BogieShimLeft = leftData ? JSON.parse(leftData) : null;
      const rightData = localStorage.getItem("bogieShimRight");
      this.inspection.BogieShimRight = rightData ? JSON.parse(rightData) : null;
    }
    //  this._inspectionService.saveInspectiondraftGeneralInfomation(this.inspection).subscribe(r => {
    //    this.inspection = r;
    //  });
    //localStorage.removeItem("bogieShimLeft");
    //localStorage.removeItem("bogieShimRight");
    console.log(this.inspection);
  }

  anyMeasurementManuallyChanged: boolean = false;

  onMeasurementChanged(manualChange: boolean) {
    this.anyMeasurementManuallyChanged = manualChange;
  }


  validationOne(event: any) {
    console.log(event);
    this.inspection.SMUReading = event;
  }

 
  validateInspection(): Observable<boolean> {
    let inspectionDateUtc;
    if (this.inspectionId > 0) {
      inspectionDateUtc = this.inspection.InspectionDate;
    } else {
      inspectionDateUtc = this.inspection?.InspectionDate
        ? new Date(this.inspection.InspectionDate)
        : null;
    }
    const request: InspectionValidatorRequest = {
      equipmentId: this.equipmentId,
      inspectionDate: inspectionDateUtc,
      newSMU: this.inspection.SMUReading,
      inspectionId: this.inspectionId
    };

    return this._inspectionService.validateInspectionForPublish(request).pipe(
      map((response: InspectionValidationViewVM) => {
        if (response.Status === 1) {
          this.inspection.SMUValidation = true;
          //this._notification.success(response.Message);
          return true;
        } else {
          this.inspection.SMUValidation = false;
          this._notification.error(response.Message);
          return false;
        }
      }),
      catchError(err => {
        this.inspection.SMUValidation = false;
        this._notification.error('SMU validation API error', err);
        return of(false); // return false on error
      })
    );
  }

  nextStep(fromStep: number) {
    if (fromStep === 0) {
      this.calculateTotalDistance();
      this.validateInspection().subscribe();
      this.updateInspectionDraft(fromStep);
      console.log(this.inspection);
      this.stepOneSubmitted = true;
      this.warningMessage = '';
      if (this.inspection.PMUReading == null || this.inspection.PMUReading == undefined) {
        this.inspection.PMUReading = 0;
      }
      if (!this.othersTabDataLoaded) {
        this.othersTabDataLoaded = true;
        this.leftFrameSystem.loadSystem(this.inspection.SMUReading, this.inspection.PMUReading);
        this.leftChainSystem.loadSystem(this.inspection.SMUReading, this.inspection.PMUReading);
        this.rightChainSystem.loadSystem(this.inspection.SMUReading, this.inspection.PMUReading);
        this.rightFrameSystem.loadSystem(this.inspection.SMUReading, this.inspection.PMUReading);
      }
      Object.keys(this.GeneralInfoGroup.controls).forEach(key => {
        if (this.GeneralInfoGroup.get(key).value === undefined || this.GeneralInfoGroup.get(key).value === null) {
          this.warningMessage += ' ' + this.translate(key) + ',';
        }
      });
      if (this.warningMessage === '') {
        this.showWaring = false;
      } else this.showWaring = true;
      if (this.inspection.InspectionId == 0)
        this.saveDraftToBackend(this.inspection);
    }
    if (fromStep === 1) {
      console.log(this.inspection);
      if (this.inspection.InspectionId == 0)
        this.saveDraftToBackend(this.inspection);
    }
    if (fromStep === 2) {
      console.log(this.inspection);
      if (this.inspection.InspectionId == 0)
        this.saveDraftToBackend(this.inspection);
    }
    if (fromStep === 3) {
      //this.calculateTotalDistance();
      console.log(this.inspection);
      this.updateInspectionDraft(fromStep);
      console.log(this.inspection);
      if (this.inspection.InspectionId == 0)
        this.saveDraftToBackend(this.inspection);
      // this.leftFrameSystemReview.loadSystem();
      // this.leftChainSystemReview.loadSystem();
      // this.rightChainSystemReview.loadSystem();
      // this.rightFrameSystemReview.loadSystem();
    }
  }

  private saveDraftToBackend(inspection: CreateNewInspectionViewModel) {
    this._inspectionService
      .saveDraft(inspection)
      .subscribe({
        error: err => console.error('Draft save failed', err)
      });
  }

  childSystemUpdated(systemData: SystemInspectionDetailView, side: number, systemType: number) {
    console.log("childMeasurementPointUpdated....", systemData, side, systemType);
    if (side == 1 && systemType == 1) {
      this.inspection.SystemDataChainLeft = systemData;
    }
    if (side == 1 && systemType == 2) {
      this.inspection.SystemDataFrameLeft = systemData;
    }
    if (side == 2 && systemType == 1) {
      this.inspection.SystemDataChainRight = systemData;
    }
    if (side == 2 && systemType == 2) {
      this.inspection.SystemDataFrameRight = systemData;
    }
  }



  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }


  openConditionComment(condition: Condition, comment: string) {
    const viewCommentModalRef = this._dialog.open(ConditionCommentModalComponent, {
      width: '1032px',
      data: {
        condition: condition,
        comment: comment,
        inspectionDraftId: this.inspection.InspectionId,
        equipmentId: this.equipmentId,
        comingFrom: CommentPopupRequestPageAndFunc.ObservationCommentsInspection
      }
    });
    viewCommentModalRef.afterClosed().subscribe(result => {
      // console.log("newComment", newComment)
      if (result?.close) {
        const newComment = result.comment;
        this._loading.startLoading();
        switch (condition) {
          case Condition.TrackSagL:
            this.inspection.ObservationComments.TrackSagLComment = newComment;
            break;
          case Condition.TrackSagR:
            this.inspection.ObservationComments.TrackSagRComment = newComment;
            break;
          case Condition.CannonExtL:
            this.inspection.ObservationComments.CannonExtLComment = newComment;
            break;
          case Condition.CannonExtR:
            this.inspection.ObservationComments.CannonExtRComment = newComment;
            break;
          case Condition.DryJointsL:
            this.inspection.ObservationComments.NoDryJointsLComment = newComment;
            break;
          case Condition.DryJointsR:
            this.inspection.ObservationComments.NoDryJointsRComment = newComment;
            break;
          case Condition.ScallopL:
            this.inspection.ObservationComments.ScallopLComment = newComment;
            break;
          case Condition.ScallopR:
            this.inspection.ObservationComments.ScallopRComment = newComment;
            break;
          case Condition.LinkNoL:
            this.inspection.ObservationComments.LinkNoLComment = newComment;
            break;
          case Condition.LinkNoR:
            this.inspection.ObservationComments.LinkNoRComment = newComment;
            break;
        }
        //this.inspection.ObservationComments = reloadComment;
        // this._inspectionService.refreshInspectionDraft(this.equipmentId).subscribe(r => {
        //   this.inspection.ObservationComments = reloadComment;
        //   this._loading.finishedLoading();
        // });
        this._loading.finishedLoading();
      }
    });
  }
  loadPreferences() {
    this._inspectionService.GetUserPreferences().subscribe(r => {
      if (r !== undefined && r !== null && r !== 'mm')
        this.measurementUnit = 'Inches';
    });

    this._inspectionService.GetUserDistancePreferences().subscribe(r => {
      if (r !== undefined && r !== null)
        this.measurementDistance = r;
    });

    this._interp.GetUserPreferenceUCConditon().subscribe(r => {
      if (r == '1')
        this.showUCCondition = true;
      else this.showUCCondition = false;
    });
  }



  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  AllOptionsEnable: boolean = true;
  getFamilyDetails(value: string) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res
        familydetails.map(x => {
          if (x.typedesc == value) {
            this.FamilyImage_Chain = x.ChainImage
            this.FamilyImage_Frame = x.FrameImage
          }
        })
        if (this.equipmentDetails && familydetails?.length) {

          const family = familydetails.find(
            f => f.type_auto === this.equipmentDetails.FamilyId
          );

          if (family) {
            this.showTrackSag = family.ShowTrackSag;
            this.showCannonExt = family.ShowCannonExt;
            this.showScallop = family.ShowScallop;
            this.showDryJoints = family.ShowDryJoints;
            this.showNumberOfLinks = family.ShowNumberOfLinks;
            this.showUnderFootConditions = family.ShowUnderFootConditions;
            this.showWorkOrder = family.ShowWorkOrder;
            this.AllOptionsEnable = family.ObservationsTrue;

          }

        }
      }
    })
    this.cdr.detectChanges();
  }
  ShowWarning() {
    // console.log("clikedback")
    this._notification.warn("Please note, if going back, any data added or changed will not be saved");
  }

  saveInspectionSp() {
    this.saving = true;
    this.submitted = true;
    this._loading.startLoading();

    // ALWAYS VALIDATE FIRST (for both save & update)
    this.validateInspection().subscribe(isValid => {

      if (!isValid) {
        // STOP spinner and button
        this.saving = false;
        this.submitted = false;
        this._loading.finishedLoading();
        return;
      }

      // AFTER VALIDATION SUCCESS
      if (this.inspectionId === 0) {

        // CREATE (SAVE)
        this._inspectionService.saveAndInterpreteInspectionSP(this.inspection)
          .subscribe(result => {
            this._loading.finishedLoading();

            if (result.m_Item1 == 1) {
              //this._notification.success(result.m_Item3);
              localStorage.removeItem("bogieShimLeft");
              localStorage.removeItem("bogieShimRight");
              setTimeout(() => {
                this.saving = false;
                this._router.navigate(['/interpretation', result.m_Item2]);
              }, 2000);

            } else {
              this.saving = false;
              this.submitted = false;
              this._notification.error(result.m_Item3);
            }
          });

      } else {

        // UPDATE
        this._inspectionService.updateInspectionSP(this.inspection)
          .subscribe(result => {
            this._loading.finishedLoading();

            if (result.m_Item1 == 1) {
              //this._notification.success(result.m_Item3);
              localStorage.removeItem("bogieShimLeft");
              localStorage.removeItem("bogieShimRight");
              setTimeout(() => {
                this.saving = false;
                this._router.navigate(['/interpretation', result.m_Item2]);

              }, 2000);

            } else {
              this.saving = false;
              this.submitted = false;
              this._notification.error(result.m_Item3);
            }
          });
      }
    });
  }


  saveInspection() {
    this.saving = true;
    this.submitted = true;
    this._loading.startLoading();
    if (this.inspectionId === 0) {
      this._inspectionService.saveAndInterpreteInspection(this.equipmentId).subscribe(result => {
        this._loading.finishedLoading();
        if (result.m_Item1) {
          this._notification.success(result.m_Item2);
          setTimeout(() => {
            this.saving = false;
            this._router.navigate(['/interpretation', result.m_Item3]);
          }, 2000);
        } else {
          this.saving = false;
          this.submitted = false;
          this._notification.error(result.m_Item2);
        }
      });
      this._loading.finishedLoading();
    } else {
      this._inspectionService.updateInspection(this.equipmentId, this.inspectionId).subscribe(result => {
        this._loading.finishedLoading();
        if (result.m_Item1) {
          this._notification.success(result.m_Item2);
          setTimeout(() => {
            this.saving = false;
            this._router.navigate(['/interpretation', result.m_Item3]);
          }, 2000);
        } else {
          this.submitted = false;
          this.saving = false;
          this._notification.error(result.m_Item2);
        }
      });
      this._loading.finishedLoading();
    }

  }
  selectedQuoteId: number = -1;
  loadSelectedQuote(_inspectionId: number) {
    this._interp.getInterpretationSelectedQuoteId(_inspectionId).subscribe(QuoteId => {
      this.selectedQuoteId = QuoteId;
      if (this.selectedQuoteId > 1) {
        this.callReleaseReportApi(_inspectionId, this.selectedQuoteId);
      } else {
        this.addQuote(true, false, _inspectionId)
      }
    });
  }
  saveInspectionAndSendReport() {
    this.saving = true;
    this.submitted = true;
    this._loading.startLoading();
    if (this.inspectionId === 0) {
      this._inspectionService.saveAndInterpreteInspection(this.equipmentId).subscribe(result => {
        //this._loading.finishedLoading();
        if (result.m_Item1) {
          this._notification.success(result.m_Item2);
          setTimeout(() => {
            this.saving = false;
            //this._router.navigate(['/interpretation', result.m_Item3]);

            this.loadSelectedQuote(result.m_Item3);

          }, 2000);
        } else {
          this.saving = false;
          this.submitted = false;
          this._notification.error(result.m_Item2);
        }
      });
      this._loading.finishedLoading();
    }
  }

  openSendReport(_inspectionId, selectedQuoteId) {
    const ref = this._dialog.open(SendReportModalComponent, {
      data: {
        inspectionId: _inspectionId,
        selectedQuoteId: selectedQuoteId,
        selectedTemperatureId: 0,
        equipment_id: this.equipmentId,
        InspectorName: this.equipmentDetails.LoggedUser
      }
    });
    ref.afterClosed().subscribe(result => {
      if (result == true) {
        this._router.navigate(['/interpretation', _inspectionId]);
      } else {
        // this._notification.warn("Please note, if going back, any data added or changed will not be saved");
        this._router.navigate(['/interpretation', _inspectionId]);
      }
    });
  }
  callReleaseReportApi(_inspectionId, selectedQuoteId) {
    this._interp.releaseReport(_inspectionId, selectedQuoteId).subscribe(r => {
      if (r.m_Item1) {
        this.openSendReport(_inspectionId, selectedQuoteId);
      } else {

      }
    }, err => {
      console.error(err);

    });
  }
  addQuote(callReleaseReport: boolean = true, callDownloadPdf: boolean = false, _inspectionId) {
    this._interp.addQuote(_inspectionId).subscribe(r => {
      if (r.m_Item1 > 0) {

        this.callReleaseReportApi(_inspectionId, r.m_Item1);

      } else {

      }
    }, err => {
      //this._notify.error('Error', 'Failed to add a new quote which is required to release the inspection. Please contact TrackTreads support. ');
      console.error(err);
    });
  }

  viewAdditionalObservationListPhoto(additionalOb: InspectionAdditionalObservationListsViewModel, imageData: InspectionAdditionalObservationImagesVM) {
    const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
      data: {
        comingFrom: this.popupEndPoint,
        observationList: additionalOb,
        imageData: imageData,
        isImagePath: true,
        inspectionId: this.inspection.InspectionId
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
      if (reloadPhoto) {
        console.log(imageData);
        additionalOb.ObsImages = additionalOb.ObsImages?.filter(img => !(img.Image === '' && img.ImagePath === ''));
        // this.reloadAdditionalObservationPhoto(additionalOb);
        //this.reloadAdditionalObservationList();
      }
    });
  }


  AddObservationListComment(additionalOb: InspectionAdditionalObservationListsViewModel) {
    const viewCommentModalRef = this._dialog.open(ConditionCommentModalComponent, {
      width: '1032px',
      data: {
        comingFrom: CommentPopupRequestPageAndFunc.ObservationListCommentCreateInspection,
        additionalObservation: additionalOb,
        inspectionDraftId: this.inspection.InspectionId,
        comment: additionalOb.Comment,
        isCreateNewSP: true
      }
    });
    viewCommentModalRef.afterClosed().subscribe(result => {
      if (result) {
        additionalOb.Comment = result.comment;
        //this.reloadAdditionalObservationComment(additionalOb);
      }
    });
  }

  OpenDeleteAdditionalObs(obsId: number, title: string) {
    const viewPhotoModalRef = this._dialog.open(ConfirmDialogComponent, {
      data: {
        isEdit: false,
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(res => {
      if (res == true) {
        if (this.inspectionId == undefined) {
          this._inspectionService.DeleteInspectionDraftObservationLists(obsId).subscribe(res => {
            if (res > 0) {
              this.reloadAdditionalObservationList();
            }
          });
        }
        else {
          this.inspection.AdditionalObservationDrafts = this.inspection.AdditionalObservationDrafts.filter(x => x.Title !== title);
        }
      }
    });
  }

  reloadAdditionalObservationList() {
    this._loading.startLoading();
    this._inspectionService.getInspectionDraftObservationLists(this.inpsectionDraftId).subscribe(r => {
      this._loading.finishedLoading();
      this.inspection.AdditionalObservationDrafts = r;
    });
  }


  AnswerAdditonalObs(obs: InspectionAdditionalObservationListsViewModel) {
    // console.log("Data", obs);
    const dialogRef = this._dialog.open(AdditionalComponentAnswerComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        InspectionAdditionalObsId: obs.Id,
        AdditionalObsRefId: obs.ReferenceId,
        AnswerList: obs.AnswerList,
        QuestionTypeId: obs.QuestionTypeId,
        isCreateNew: true,
        isCreateNewSP: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.close == true) {
        obs.AnswerList = result.AnswerList;
        obs.HasAnswerd = true;
        console.log('obs', obs);
        console.log('obs.AnswerList', obs.AnswerList);
        //this.reloadAdditionalObservationList();
      }
    });
  }
  reloadAdditionalObservationComment(obs: InspectionAdditionalObservationListsViewModel) {
    this._loading.startLoading();
    this._inspectionService.getInspectionDraftObservationListsComment(obs.Id).subscribe(r => {
      this._loading.finishedLoading();

      obs.Comment = r;
    });
  }

  reloadAdditionalObservationPhoto(obs: InspectionAdditionalObservationListsViewModel, event: any) {
    this._loading.startLoading();
    console.log(event);
    obs.ObsImages.push({
      Image: event.image,
      Id: Date.now(),
      AdditionalInspectionId: obs.Id ?? 0,
      ImagePath: event.imagePath
    });
    // this._inspectionService.getInspectionDraftObservationPhotoList(obs.Id).subscribe(r => {
    //  obs.ObsImages = r;
    // });
    obs.ObsImages.forEach(img => {
      if (img.Image && (!img.ImagePath || img.ImagePath === '')) {
        img.ImagePath = this.extractImagePath(img.Image);
      }
    });
    console.log(obs);
    this._loading.finishedLoading();
  }

  extractImagePath(url: string): string {
    if (!url) return '';

    const parts = url.split('.com/');
    return parts.length > 1 ? parts[1] : url;
  }



  GetBorderColour(value, type: string) {
    if (type == 'TS') {
      if (this.hasCRoller && this.showCRoller) {
        let info = this.observationInfo.find(x => x.Title == 'Track Sag with Carrier Roller')
        if (info != null && value != '' && value != null) {
          if (value <= info.Max && value >= info.Min) return 'pass';
          else if (value > info.Max) return 'loose'
          else if (value < info.Min) return 'fail'
        } else if (info == null && value != '' && value != null) return 'notmeasure';
        else return '';
      } else {
        let info = this.observationInfo.find(x => x.Title == 'Track Sag without Carrier Roller')
        if (info != null && value != '' && value != null) {
          if (value <= info.Max && value >= info.Min) return 'pass';
          else if (value > info.Max) return 'loose'
          else if (value < info.Min) return 'fail'
        } else if (info == null && value != '' && value != null) return 'notmeasure';
        else return '';
      }
    } else if (type == 'CE') {
      let info = this.observationInfo.find(x => x.Title == 'Cannon Extension')
      if (info != null && value != '' && value != null) {
        if (value < info.Max) return 'pass';
        else return 'fail';
      } else if (info == null && value != '' && value != null) return 'notmeasure';
      else return '';

    } else if (type == 'S') {
      let info = this.observationInfo.find(x => x.Title == 'Scallop')
      if (info != null && value != '' && value != null) {
        if (value < info.Max) return 'pass';
        else return 'fail';
      } else if (info == null && value != '' && value != null) return 'notmeasure';
      else return '';
    }
    else {
      return '';
    }
  }

  visibility(type: string) {
    if (type == 'TS') {
      if (this.hasCRoller == true) {
        let hasdata = this.observationInfo.find(x => x.Title == 'Track Sag with Carrier Roller');
        if (hasdata == null && this.observationInfo.length > 0) return false
        else return true;
      } else {
        let hasdata = this.observationInfo.find(x => x.Title == 'Track Sag without Carrier Roller');
        if (hasdata == null && this.observationInfo.length > 0) return false
        else return true;
      }
    } else if (type == 'CE') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Cannon Extension');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;

    } else if (type == 'S') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Scallop');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;

    } else if (type == 'DJ') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Dry Joints');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;

    } else if (type == 'L') {
      let hasdata = this.observationInfo.find(x => x.Title == '# of Links');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;
    }
  }

  addImagesSystem(event: any) {
    console.log("addImagesSystem event:", event);
    //this.inspection.SystemDataChainLeft.SystemId
  }

}


